import { ReactNode, createContext, useContext, useMemo, useState } from 'react';

interface SideBarContextType {
  sidebar: boolean;
  setSidebar: React.Dispatch<React.SetStateAction<boolean>>;
}

const SideBarContext = createContext<SideBarContextType | undefined>(undefined);

interface SidebarProviderProps {
  children: ReactNode;
}

export function SidebarProvider({ children }: SidebarProviderProps) {
  const [sidebar, setSidebar] = useState(true);

  const value = useMemo(() => {
    return {
      sidebar,
      setSidebar,
    };
  }, [sidebar]);

  return <SideBarContext.Provider value={value}>{children}</SideBarContext.Provider>;
}

export function useSidebar() {
  const context = useContext(SideBarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
}
